const CART_KEY = 'studio_crochet_cart';

const cartStore = {
  getCart() {
    try {
      const raw = localStorage.getItem(CART_KEY);
      if (!raw) return [];
      const data = JSON.parse(raw);
      // Validate cart structure
      if (!Array.isArray(data)) return [];
      return data.filter(item => item && item.product_id && item.quantity > 0);
    } catch (_) {
      return [];
    }
  },

  saveCart(items) {
    localStorage.setItem(CART_KEY, JSON.stringify(items));
    window.dispatchEvent(new Event('cartUpdated'));
  },

  addToCart(product, quantity = 1, color = '', size = '') {
    const items = this.getCart();
    const existing = items.find(
      (i) => i.product_id === product.id && i.color === color && i.size === size
    );

    if (existing) {
      existing.quantity += quantity;
    } else {
      items.push({
        id: `${product.id}-${color}-${size}-${Date.now()}`,
        product_id: product.id,
        product: {
          id: product.id,
          name: product.name,
          price: product.price,
          discount_price: product.discount_price,
          images: product.images,
          category: product.category,
          stock: product.stock,
        },
        quantity,
        color,
        size,
      });
    }

    this.saveCart(items);
  },

  updateQuantity(id, quantity) {
    const items = this.getCart();
    const item = items.find((i) => i.id === id);
    if (item) {
      item.quantity = Math.max(1, quantity);
      this.saveCart(items);
    }
  },

  removeItem(id) {
    const items = this.getCart().filter((i) => i.id !== id);
    this.saveCart(items);
  },

  clearCart() {
    localStorage.removeItem(CART_KEY);
    window.dispatchEvent(new Event('cartUpdated'));
  },

  getCartCount() {
    return this.getCart().reduce((sum, item) => sum + item.quantity, 0);
  },

  getTotal() {
    return this.getCart().reduce((sum, item) => {
      const price = item.product?.discount_price || item.product?.price || 0;
      return sum + price * item.quantity;
    }, 0);
  },
};

export default cartStore;
